import { render, staticRenderFns } from "./psnlist.vue?vue&type=template&id=5649d318&scoped=true&"
import script from "./psnlist.vue?vue&type=script&lang=js&"
export * from "./psnlist.vue?vue&type=script&lang=js&"
import style0 from "./psnlist.vue?vue&type=style&index=0&id=5649d318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649d318",
  null
  
)

export default component.exports